<template>
  <div class="page__wrapper" @scroll="onScroll()">
    <FCCopy :h2="this.h2" :h3="this.h3">
      <template v-slot:copy>
        <strong>One of the most unique club designs in sports, the First Financial Club is a fresh take on a beer hall but customized to a modern Cincinnati. The OTR-inspired space features communal tables, double-height ceilings, exposed brick and oversized murals. A private entrance makes this the perfect pre-game gathering spot.</strong>
        <p class="map">
          <img
            src="~@/assets/maps/map-firstfinancial.png"
            alt
            data-aos="zoom-in-up"
            data-aos-duration="250"
            data-aos-easing="ease-out-cubic"
          />
        </p>
      </template>
    </FCCopy>
  </div>
</template>

<script>
import FCCopy from "@/components/patterns/FCCopy";
export default {
  components: {
    FCCopy
  },
  mounted() {
    const ref = this.$store.state.menu.firstFinancialClub.ref;
    const index = this.$store.state.menu.menuItems.map(e => e.ref).indexOf(ref);
    this.$store.state.menu.activeSection = index;
    this.$store.state.menu.currentSectionTitle = this.$store.state.menu.firstFinancialClub.title;
    this.$store.state.menu.currentSectionNavigation = this.$store.state.menu.firstFinancialClub.nav;
    this.onScroll();
  },
  data() {
    return {
      h2: "First Financial Club",
      h3: "Intro"
    };
  }
};
</script>

<style lang="scss" scoped>
.page__wrapper {
  background-image: url("~@/assets/backgrounds/bg-first-financial-intro.jpg");
  background-size: cover;
  background-position: center;
}
</style>